import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Snackbar from "@material-ui/core/Snackbar";
import { withRouter } from "react-router-dom";

import { green } from "@material-ui/core/colors";

import { GetAllFestivals, AddFestivalProduct } from "../../fetchs";

import "./product.styles.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  buttonProgress: {
    color: green[500],
    position: "relative",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Count: "",
      CountHelper: "",
      DiscountPriceFestival: "",
      DiscountPriceFestivalHelper: "",
      captionCount: 0,
      FestivalId: "",
      goodsTypeId: 0,
      subCategoryId: 0,
      name: "",
      imageAddress: "",
      liter: "",
      countInPack: 0,
      description: "",
      mostSell: false,
      mostOff: false,
      goodsCosts: [],
      festivals: [],
      goodsTypes: [],
      subCategories: [],
      cities: [],
      loading: false,
      saving: false,
      uploadPic: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    GetAllFestivals(0, 9999999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ festivals: responseJson.data });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSave = () => {
    AddFestivalProduct({
      ProductId: this.props.match.params.productId,
      FestivalId: this.state.FestivalId,
      Count: this.state.Count,
      DiscountPriceFestival: this.state.DiscountPriceFestival,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای اضافه شدن جشنواره");
        } else if (response.status === 200) {
          toast.success("جشنواره با موفقیت اضافه شد");
          this.props.history.push("/main/products");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "Count":
        this.setState({ Count: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({ CountHelper: "لطفا تعداد را وارد کنید" });
        } else {
          this.setState({ CountHelper: "" });
        }
        break;
      case "DiscountPriceFestival":
        this.setState({ DiscountPriceFestival: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({
            DiscountPriceFestivalHelper: "لطفا قیمت تخفیف خورده را وارد کنید",
          });
        } else {
          this.setState({ DiscountPriceFestivalHelper: "" });
        }
        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component='h1' variant='h4' align='center'>
              افزودن محصول به جشنواره
            </Typography>
            <Grid container>
              <Grid item md={12}>
                <React.Fragment>
                  <form
                    className={classes.container}
                    noValidate
                    autoComplete='off'
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={
                            this.state.FestivalId.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.FestivalId.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                          id='standard-select-goodsType'
                          select
                          label=' لیست فستیوال ها'
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.FestivalId}
                          onChange={this.handleChange("FestivalId")}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin='normal'
                        >
                          {this.state.festivals.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={this.state.CountHelper.length !== 0}
                          helperText={this.state.CountHelper}
                          onChange={this.onchange}
                          id='Count'
                          label='تعداد'
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.Count}
                          margin='normal'
                          InputLabelProps={
                            this.state.Count.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.Count.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={
                            this.state.DiscountPriceFestivalHelper.length !== 0
                          }
                          helperText={this.state.DiscountPriceFestivalHelper}
                          onChange={this.onchange}
                          id='DiscountPriceFestival'
                          label='قیمت تخفیف خورده'
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.DiscountPriceFestival}
                          margin='normal'
                          InputLabelProps={
                            this.state.DiscountPriceFestival.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.DiscountPriceFestival.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item lg={4}></Grid>

                      <Grid item lg={4}>
                        <Button
                          variant='contained'
                          color='primary'
                          fullWidth
                          disabled={
                            this.state.loading ||
                            this.state.CountHelper.length !== 0 ||
                            this.state.Count.length === 0 ||
                            this.state.DiscountPriceFestivalHelper.length !==
                              0 ||
                            this.state.DiscountPriceFestival.length === 0 ||
                            this.state.FestivalId.length === 0
                          }
                          onClick={this.handleSave}
                        >
                          ذخیره
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
            </Grid>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id='message-id'> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Product.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Product));
